import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";
import { StrapiMainCategory, StrapiStore } from "~/shared-types";
import { getFormattedImageAttributes } from "~/utils/getImageAttributes";
import { getRoute } from "~/utils/getRoute";
import { Heading, HTMLLevels } from "../Heading";
import { Text } from "../Text";

type StoreListCardProps = {
  store: StrapiStore;
  className?: string;
};

const MainCategoryLink = ({ category }: { category: StrapiMainCategory }) => (
  <Link
    className="hover:underline bg-secondary text-white px-2 py-1 rounded"
    href={getRoute("/categories/:categoryId/:categoryName", {
      categoryId: category.id,
      categoryName: category.attributes.name,
    })}
  >
    {category.attributes.name}
  </Link>
);
export const StoreListCard = ({ store, className }: StoreListCardProps) => {
  const { id, attributes } = store;
  const { name, slug, storeImage, companyAddress, mainCategories } = attributes;

  const fullAddress = [];
  if (companyAddress?.line1) fullAddress.push(companyAddress.line1 + ", ");
  if (companyAddress?.postCode) fullAddress.push(companyAddress.postCode + " ");
  if (companyAddress?.city) fullAddress.push(companyAddress.city);

  return (
    <div className={classNames("flex items-center gap-5 relative", className)}>
      <Link href={slug ? getRoute("/producenter/:slug", { slug }) : getRoute("/producenter/:id/:name", { id, name })} className="absolute w-full h-full z-10" />
      <div>
        {storeImage.data && (
          <Image
            {...getFormattedImageAttributes(storeImage.data, "thumbnail")}
            alt={name}
            className="rounded-xl min-w-24 h-24 w-24 object-cover"
          />
        )}
      </div>
      <div>
        <Link href={slug ? getRoute("/producenter/:slug", { slug }) : getRoute("/producenter/:id/:name", { id, name })}>
          <Heading level={HTMLLevels.h4} className="text-xl mb-1">
            {name}
          </Heading>
        </Link>
        {mainCategories?.data?.length ? (
          <Text className="text-xs text-secondary-600 mb-2 flex gap-x-1 gap-y-3 flex-wrap">
            {mainCategories?.data?.map((mainCategory, index) => (
              <span key={mainCategory.id}>
                <MainCategoryLink category={mainCategory} />

              </span>
            ))}
          </Text>
        ) : null}
        {
          store.attributes.showAddressOnMap ? <Text className="text-2xs text-secondary-600">
            {fullAddress.join("")}
          </Text> : null
        }
      </div>
    </div>
  );
};
